<template>
  <div class="internal-resource">
    <van-nav-bar
      title="内部资源"
      fixed
    />

    <div class="filter-bar">
      <div class="filter-left">
        <van-tag
          :type="selectedType === '' ? 'primary' : 'default'"
          @click="selectType('')"
          class="filter-tag"
        >
          全部
        </van-tag>
        <van-tag
          :type="selectedType === 'quark' ? 'primary' : 'default'"
          @click="selectType('quark')"
          class="filter-tag"
        >
          夸克
        </van-tag>
        <van-tag
          :type="selectedType === 'uc' ? 'primary' : 'default'"
          @click="selectType('uc')"
          class="filter-tag"
        >
          UC
        </van-tag>
        <van-tag
          :type="selectedType === 'baidu' ? 'primary' : 'default'"
          @click="selectType('baidu')"
          class="filter-tag"
        >
          百度
        </van-tag>
      </div>
      <div class="sort-control" @click="toggleSort">
        <span>上传日期</span>
        <div class="sort-arrows">
          <van-icon 
            name="arrow-up" 
            :class="['arrow-icon', order === 'desc' ? 'active' : '']"
          />
          <van-icon 
            name="arrow-down" 
            :class="['arrow-icon', order === 'asc' ? 'active' : '']"
          />
        </div>
      </div>
    </div>

    <div class="content">
      <van-loading v-if="loading" class="loading" />

      <div class="list" v-if="!loading && list.length > 0">
        <div
          v-for="item in list"
          :key="item.id"
          class="list-item"
        >
          <div class="item-content">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-meta">
              <van-tag size="mini" :type="item.type === 'quark' ? 'success' : 'warning'" class="type-tag">
                {{ item.type === 'quark' ? '夸克' : item.type === 'uc' ? 'UC' : '百度' }}
              </van-tag>
              <span class="item-date">{{ item.creatDate }}</span>
            </div>
          </div>
          <div class="item-action">
            <van-button size="small" type="primary" @click="handleGet(item)">立即获取</van-button>
          </div>
        </div>
      </div>

      <div class="pagination-wrapper" v-if="!loading && total > 0">
        <div class="page-info">
          共 {{ total }} 条，第 {{ page }} / {{ totalPages }} 页
        </div>
        <div class="page-btns">
          <van-button
            size="small"
            :disabled="page <= 1"
            @click="prevPage"
          >上一页</van-button>
          <van-button
            size="small"
            :disabled="page >= totalPages"
            @click="nextPage"
          >下一页</van-button>
        </div>
      </div>

      <div v-if="!loading && list.length === 0" class="empty">
        暂无数据
      </div>
    </div>

    <van-dialog
      v-model:show="showDialog"
      title="资源详情"
      show-confirm-button
      :show-cancel-button="true"
      confirm-button-text="复制"
      cancel-button-text="关闭"
      @confirm="handleCopy"
      @cancel="showDialog = false"
    >
      <div class="dialog-content">
        <div class="dialog-row">
          <span class="dialog-label">链接：</span>
          <div class="dialog-value dialog-url">{{ dialogData.url || '无' }}</div>
        </div>
        <div class="dialog-row" v-if="dialogData.password">
          <span class="dialog-label">密码：</span>
          <div class="dialog-value dialog-password">{{ dialogData.password }}</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getPanList, getPanDetail, getUserInfo } from '../utils/api';

export default {
  name: 'InternalResource',
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0,
      loading: false,
      selectedType: '',
      order: 'desc',
      showDialog: false,
      dialogData: {
        url: '',
        password: ''
      },
      currentId: null
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          order: this.order
        };
        if (this.selectedType) {
          params.type = this.selectedType;
        }
        const res = await getPanList(params);
        if (res && res.code === 200) {
          this.list = res.data.list || [];
          this.total = res.data.pagination.total;
          this.totalPages = res.data.pagination.totalPages;
        }
      } catch (error) {
        console.error('Fetch data error:', error);
        this.$toast('加载失败');
      } finally {
        this.loading = false;
      }
    },
    selectType(type) {
      this.selectedType = type;
      this.page = 1;
      this.fetchData();
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.fetchData();
      }
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.fetchData();
      }
    },
    toggleSort() {
      this.order = this.order === 'desc' ? 'asc' : 'desc';
      this.page = 1;
      this.fetchData();
    },
    async handleGet(item) {
      if (!this.checkLogin()) {
        return;
      }
      
      const valid = await this.checkVipStatus();
      if (!valid) {
        return;
      }
      
      this.currentId = item.id;
      this.dialogData = { url: '', password: '' };
      this.showDialog = false;
      
      try {
        const res = await getPanDetail(item.id);
        if (res && res.code === 200) {
          this.dialogData = res.data;
          this.showDialog = true;
        }
      } catch (error) {
        console.error('Fetch detail error:', error);
        this.$toast('获取资源详情失败');
      }
    },
    checkLogin() {
      const userinfo = localStorage.getItem('userinfo');
      if (!userinfo) {
        this.$toast('请先登录');
        setTimeout(() => {
          this.$router.push('/login');
        }, 500);
        return false;
      }
      return true;
    },
    async checkVipStatus() {
      const userinfo = localStorage.getItem('userinfo');
      if (!userinfo) return false;
      
      try {
        const parsed = JSON.parse(userinfo);
        if (!parsed || !parsed.data) return false;
        
        const userId = parsed.data.id;
        const res = await getUserInfo(userId);
        
        if (res && res.code === 200) {
          const userData = res.data;
          
          const isVip = userData.isVip === 'true';
          const vipTime = typeof userData.creatVipTime === 'string' 
            ? parseInt(userData.creatVipTime) * 1000 
            : userData.creatVipTime * 1000;
          const now = Date.now();
          const isExpired = vipTime ? now > vipTime : true;
          
          if (!isVip) {
            this.$toast('您还不是会员，请充值');
            setTimeout(() => {
              this.$router.push('/profile');
            }, 1000);
            return false;
          }
          
          if (isExpired) {
            this.$toast('会员已到期，请续费');
            setTimeout(() => {
              this.$router.push('/profile');
            }, 1000);
            return false;
          }
          
          return true;
        }
      } catch (error) {
        console.error('Check vip error:', error);
        this.$toast('验证失败');
        return false;
      }
      
      return true;
    },
    async handleCopy() {
      if (this.dialogData.password) {
        try {
          await navigator.clipboard.writeText(this.dialogData.password);
          this.$toast.success('密码已复制');
        } catch (err) {
          const textarea = document.createElement('textarea');
          textarea.value = this.dialogData.password;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
          this.$toast.success('密码已复制');
        }
      }
      if (this.dialogData.url) {
        const link = document.createElement('a');
        link.href = this.dialogData.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      this.showDialog = false;
    }
  }
};
</script>

<style scoped>
.internal-resource {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 46px;
}

.filter-bar {
  background: #fff;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 46px;
  z-index: 10;
}

.filter-left {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.filter-tag {
  flex-shrink: 0;
  cursor: pointer;
}

.sort-control {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  padding: 6px 10px;
  background: #f7f8fa;
  border-radius: 4px;
  user-select: none;
}

.sort-control:active {
  background: #e5e6eb;
}

.sort-arrows {
  display: flex;
  flex-direction: column;
  gap: 1px;
  align-items: center;
  justify-content: center;
}

.arrow-icon {
  font-size: 10px;
  color: #999;
  height: 8px;
  line-height: 8px;
}

.arrow-icon.active {
  color: #1989fa;
}

.content {
  padding: 12px;
}

.loading {
  text-align: center;
  padding: 20px;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.list-item {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item-content {
  flex: 1;
  margin-right: 12px;
  overflow: hidden;
}

.item-title {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 6px;
}

.item-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.type-tag {
  flex-shrink: 0;
}

.item-date {
  font-size: 12px;
  color: #999;
}

.item-action {
  flex-shrink: 0;
}

.dialog-content {
  padding: 16px;
  text-align: left;
}

.dialog-row {
  margin-bottom: 12px;
}

.dialog-row:last-child {
  margin-bottom: 0;
}

.dialog-label {
  display: block;
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
}

.dialog-value {
  font-size: 14px;
  color: #333;
  word-break: break-all;
}

.dialog-url {
  color: #1989fa;
  font-size: 13px;
}

.dialog-password {
  font-family: monospace;
  background: #f7f8fa;
  padding: 6px 10px;
  border-radius: 4px;
  display: inline-block;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.page-btns {
  display: flex;
  gap: 8px;
}

.empty {
  text-align: center;
  padding: 40px;
  color: #999;
}

.pagination-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
</style>
